module.exports = __webpack_public_path__ + "static/img/优惠券背景@3x.f731433.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/购物车/优惠券背景@3x.png
// module id = VUSd
// module chunks = 192